import { parseDate } from '../../../utils/time';

// Submits form implemented with `react-hook-form` by ref
// useful in cases where ui designs prevent us from defining
// submit button inside the form
// https://github.com/react-hook-form/react-hook-form/issues/566#issuecomment-730077495
export function submitFormByRef(formRef: ExplicitAny) {
  formRef.current?.dispatchEvent(
    new Event('submit', { cancelable: true, bubbles: true }),
  );
}

// maps ISO date string (yyyy-mm-dd, returned e.g. from <input type="date" />)
// to validity end date
export function mapDateInputToValidityEnd(
  isoDate?: string,
  isIndefinite = false,
) {
  if (isIndefinite) {
    return null;
  }

  if (!isoDate) {
    throw new Error('End date must either be indefinite or set!');
  }

  return parseDate(isoDate);
}
